import { linearModel } from 'mobx-store';

import {
  getSelectedParameterType,
  getFilteredParameterValuesNotEmpty,
  getFilteredParametersValuesNotEmpty
} from 'store/dataset';

const getParameter = (state, parameterName) => ({
  name: parameterName,

  type: getSelectedParameterType(state, parameterName),
  values: getFilteredParameterValuesNotEmpty(state, parameterName)
});

const getConnectedParameters = (
  state,
  primaryParameterName,
  secondaryParameterName
) => {
  const {
    firstParsedParameterValues,
    secondParsedParameterValues
  } = getFilteredParametersValuesNotEmpty(
    state,
    primaryParameterName,
    secondaryParameterName
  );

  return [
    {
      name: primaryParameterName,
      type: getSelectedParameterType(state, primaryParameterName),
      values: firstParsedParameterValues.length >= 2 ? firstParsedParameterValues : []
    },
    {
      name: secondaryParameterName,
      type: getSelectedParameterType(state, secondaryParameterName),
      values: secondParsedParameterValues.length >= 2 ? secondParsedParameterValues : []
    }
  ];
};

export const setPrimaryAndSecondary = (
  primaryParameterName,
  secondaryParameterName
) => {
  return (dispatch, getState) => {
    const state = getState();

    if (primaryParameterName && secondaryParameterName) {
      linearModel.setPrimaryAndSecondary(
        ...getConnectedParameters(state, primaryParameterName, secondaryParameterName)
      );
    }
  };
};

export const setPrimaryAndResetSecondary = primaryParameterName => (dispatch, getState) =>
  linearModel.setPrimaryAndResetSecondary(getParameter(getState(), primaryParameterName));

export const setSecondaryParameter = secondaryParameterName => (dispatch, getState) => {
  const connectedParameters = getConnectedParameters(getState(), linearModel.primaryParameter.name, secondaryParameterName);
  const isLackOfObservations = connectedParameters.some(({ values }) => values.length < 2);

  if (linearModel.primaryParameter.name && secondaryParameterName && !isLackOfObservations) {
    linearModel.setPrimaryAndSecondary(...connectedParameters);
  }
};
